var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dpp-editor"
  }, [_c('h4', {
    ref: "mainHeader",
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "breadcrumb-link",
    on: {
      "click": function ($event) {
        return _vm.goTo('products');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('products')))]), _vm._v(" > "), _c('span', {
    staticClass: "breadcrumb-link",
    on: {
      "click": function ($event) {
        return _vm.goToProductDetails('info');
      }
    }
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" > "), _c('span', {
    staticClass: "breadcrumb-link",
    on: {
      "click": function ($event) {
        return _vm.goToProductDetails('redirection');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scan_destination')))]), _vm._v(" > " + _vm._s(_vm.$t('digital_product_passport')) + " ")]), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _vm.editorUrl ? _c('iframe', {
    style: {
      height: _vm.iframeHeight,
      maxHeight: _vm.iframeHeight
    },
    attrs: {
      "id": "dpp-frame",
      "frameborder": "0",
      "src": _vm.editorUrl
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }